export default __webpack_public_path__ + "locales/ar-SA/MainBar.json?hash=150f25ae888d405887e4b84be390c213";